// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__khWcx","transactionProjectWrapper":"styles_transactionProjectWrapper__2bRQy"};